<template>
  <div v-if="ligacao.conference && ligacao.users">
    <v-row style="display: flex; flex-wrap: wrap; padding: 10px">
      <v-card
        style="min-width: 50%; flex: 1"
        outlined
        v-for="user in ligacao.users"
        :key="user.numero"
        :data="user"
      >
        <v-card-title style="display: flex !important">
          <v-avatar
            :color="
              '#' +
              (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6)
            "
            style="margin: auto"
          >
            <span class="white--text headline">{{
              getInitials(user.nome)
            }}</span>
          </v-avatar>
        </v-card-title>
        <v-card-text class="text-center">
          {{ user.nome }}
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="center">
            <v-btn text @click="removeUser(user)">{{ t(`remover`) }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-row>
    <!-- <div class="row">
        <v-card class="mx-auto" style="width: 80%" shaped outlined>
          <v-card-title class="text-center">
            <v-avatar color="red">
              <span class="white--text headline">{{ user.nome }}</span>
            </v-avatar>
          </v-card-title>
          <v-card-text> </v-card-text>
          <v-card-text>
            <v-spacer></v-spacer>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </div> -->
    <v-btn class="float-right" @click="modalAddUser = true">{{
      t(`addUserConference`)
    }}</v-btn>

    <v-dialog v-model="modalAddUser">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title> {{ t(`addUserConference`) }}</v-card-title>
          <v-card-text>
            <v-radio-group v-model="tipo" :mandatory="false" required>
              <v-radio :label="t(`agente`)" value="agente"></v-radio>
              <v-radio :label="t(`externo`)" value="externo"></v-radio>
            </v-radio-group>
            <b-form-group
              id="input-group-2"
              :label="t(`agente`)"
              label-for="input-2"
              v-if="tipo === `agente`"
            >
              <b-form-select id="input-2" v-model="agente" required>
                <option
                  v-for="(item, index) in agentes"
                  :key="index"
                  :value="item"
                >
                  {{ item.nome }}
                </option>
              </b-form-select>
            </b-form-group>
            <div v-else>
              <v-text-field
                v-model="addUserForm.nome"
                :label="t(`nome`)"
                required
                :rules="[(v) => !!v || 'Campo obrigatório']"
              ></v-text-field>
              <v-text-field
                v-model="addUserForm.numero"
                :label="t(`numero`)"
                required
                v-on:keyup.enter="addUser()"
                :rules="[(v) => !!v || 'Campo obrigatório']"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-footer align="right" justify="right">
            <v-btn text @click="addAgentConference()" v-if="tipo == 'agente'">{{
              t(`adicionar`)
            }}</v-btn>
            <v-btn text @click="addUser()" v-else>{{ t(`adicionar`) }}</v-btn>
          </v-card-footer>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      tipo: "agente",
      modalAddUser: false,
      valid: false,
      agente: null,
      addUserForm: {
        numero: null,
      },
      ip: "http://" + JSON.parse(localStorage.getItem("config")).servidor,
    };
  },
  computed: {
    ...mapState(`xc`, {
      atendimento: (state) => state.atendimento,
      clientes: (state) => state.clientes,
      agentes: (state) => state.agentes,
    }),
    ...mapState(`sip`, {
      calls: (state) => state.calls,
      call: (state) => state.newCall || state.newInvite,
      ligacao: (state) => state.newCall || state.newInvite,
    }),
    sortMsgById() {
      if (!this.messages) return null;
      let msg = this.messages;
      return msg.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    moment() {
      return moment;
    },
  },
  watch: {
    call(nw) {
      console.log(`aipim`, nw);
    },
  },
  methods: {
    ...mapActions(`sip`, ["addUserConference", "removeUserConference"]),
    addAgentConference() {
      if (!this.agente) return;
      if (!this.$refs.form.validate()) return;
      this.addUserForm.nome = this.agente.nome;
      this.addUserForm.ramal = this.agente.ramal;
      this.addUserForm.numero = this.addUserForm.ramal.split(`/`)[1];
      this.addUserForm.uniqueid = this.ligacao.uniqueid;
      this.addUserForm.sala = this.ligacao.dados[`X-Sala`];
      if (!this.ligacao.users) this.ligacao.users = [];
      this.ligacao.users.push({
        ramal: this.agente.ramal,
        nome: this.addUserForm.nome,
        numero: this.addUserForm.numero,
      });
      this.addUserConference.qtdParticipantes = this.ligacao.users.length;
      this.addUserConference.users = this.ligacao.users;
      console.log(`QTD`, this.ligacao.users.length);

      this.addUserConference(this.addUserForm);
      this.modalAddUser = false;
    },
    removeUser(user) {
      console.log(`user`, user);
      let index = this.ligacao.users.findIndex((u) => u.nome);
      this.ligacao.users.splice(index, 1);
      this.removeUserConference({ user: user, ligacao: this.ligacao });
    },
    addUser() {
      if (!this.$refs.form.validate()) return;
      this.addUserForm.uniqueid = this.ligacao.uniqueid;
      this.addUserForm.sala = this.ligacao.dados[`X-Sala`];
      if (!this.ligacao.users) this.ligacao.users = [];
      this.ligacao.users.push({
        nome: this.addUserForm.nome,
        numero: this.addUserForm.numero,
      });
      this.addUserConference.qtdParticipantes = this.ligacao.users.length;
      console.log(`QTD`, this.ligacao.users.length);
      this.addUserConference.users = this.ligacao.users;
      this.addUserConference(this.addUserForm);
      this.modalAddUser = false;
    },
    getInitials(nome) {
      let aux = nome.split(" ");
      let retorno = "";
      for (let letra of aux) {
        retorno += letra[0];
      }
      return retorno;
    },
    getFileName(file) {
      let name = file.caminho.split(`/`);
      return name[6];
    },
    getFromName(msg) {
      if (msg.dadosAdicionais) {
        if (typeof msg.dadosAdicionais !== "object")
          return JSON.parse(msg.dadosAdicionais).from;
        return msg.dadosAdicionais.from;
      }
    },
    formatArray(array) {
      if (typeof array !== "object") array = JSON.parse(array);
      array = array.emails;
      let retorno = "";
      for (let i = 0; i, i < array.length; i++) {
        let item = array[i];
        if (i + 1 == array.length) {
          retorno += item;
        } else {
          retorno += item + `, `;
        }
      }
      return retorno;
    },
    formataHora(dataHora) {
      moment.locale("pt-br");
      if (moment(dataHora).format("L") === moment(new Date()).format("L")) {
        return moment(dataHora).format("LT");
      } else {
        return moment(dataHora).format("lll");
      }
    },
    formataData(dataHora) {
      moment.locale("pt-br");
      return moment(dataHora).format("L");
    },
  },
};
</script>

<style>
</style>